import { Logger } from '~/plugins/log'
const logger = new Logger()
logger.setContext('Sidebar')

const getDefaultState = () => ({
  open: false,
  slug: null,
  previousUrl: '/'
})

export const state = getDefaultState

export const mutations = {
  OPEN_SIDEBAR (state, { slug = null }) {
    state.open = true
    state.slug = slug
  },
  CLOSE_SIDEBAR (state) {
    state.open = false
    state.slug = null
  },
  SET_SIDEBAR_STATE (state, open) {
    state.open = open
  },
  SET_PREVIOUS_URL (state, url) {
    state.previousUrl = url
  }
}

export const getters = {
  open: state => state.open,
  slug: state => state.slug
}

export const actions = {
  OPEN_SIDEBAR_PAGE ({ commit }, { slug }) {
    if (process.browser) {
      const target = this.localePath(`/info/${slug}`)
      commit('SET_PREVIOUS_URL', window.location.href)
      window.history.pushState(null, target, target)
    }

    commit('OPEN_SIDEBAR', { slug })
  },
  CLOSE_SIDEBAR_PAGE ({ commit, state }) {
    let previousUrl = state.previousUrl || this.localePath('/')
    if (previousUrl.includes('/info/')) previousUrl = this.localePath('/')

    window.history.pushState(null, previousUrl, previousUrl)
    commit('CLOSE_SIDEBAR')
  }
}
